import { Ng2StateDeclaration } from '@uirouter/angular';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';
import { FiBusinessUnitStateResolveDataFieldGroup } from './resolve/data-field-group';
import { FiBusinessUnitStateResolveDataFields } from './resolve/data-fields';
import { FiBusinessUnitStateResolvePageTitle } from './resolve/page-title';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiBusinessUnitEditNewLayoutComponent } from '@fi-app/business-unit/business-unit-edit/fi-business-unit-edit-new-layout/fi-business-unit-edit-new-layout.component';
import {
    FiCoreUnitResolve_lightWeightAreas,
    FiCoreUnitResolve_lightWeightBusinessAreas,
    FiCoreUnitResolve_lightWeightClusters,
    FiCoreUserUnitResolve_accessRightFilterCollection,
} from '@fi-app/business-unit/states/resolve/access-right';

export const FiBusinessUnitAddV2State: Ng2StateDeclaration = {
    name: FiStateNames.BusinessUnit.AddV2,
    url: '/AddV2',
    views: {
        '@': {
            component: FiBusinessUnitEditNewLayoutComponent,
        },
    },
    resolve: {
        businessUnit: [BusinessUnitService, FiBusinessUnitAddStateResolve_businessUnit],
        lightWeightClusters: FiCoreUnitResolve_lightWeightClusters,
        lightWeightBusinessAreas: FiCoreUnitResolve_lightWeightBusinessAreas,
        areasAvailableForBusinessUnit: FiCoreUnitResolve_lightWeightAreas,
        accessRightFilterCollection: FiCoreUserUnitResolve_accessRightFilterCollection,
        dataFieldGroup: FiBusinessUnitStateResolveDataFieldGroup,
        businessUnitDataFields: FiBusinessUnitStateResolveDataFields,
        pageTitle: FiBusinessUnitStateResolvePageTitle,
    },
};

export function FiBusinessUnitAddStateResolve_businessUnit(businessUnitService: BusinessUnitService) {
    return businessUnitService.getBusinessUnit(0);
}
